/* eslint-disable no-dupe-keys */
import axios from 'axios'

let headers

const API_ROOT = process.env.NEXT_PUBLIC_API_ROOT

const handleErrors = async (error) => {
    let result = {}
    const data = error && error.response && error.response.data
    const status = error && error.response && error.response.status

    result = {
        status: status,
        data: data,
        error: true
    }

    return result
}

const handleResponse = res => {
    return {
        status: res.status,
        data: res.data
    }
}


const createApi = (authToken = null) => {
 
  
    if (authToken) {
        headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Content-Type': 'application/json',
            Authorization: `Token ${authToken.replace(/['"]+/g, '')}`
        }
    } else {
       

        headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Content-Type': 'application/json'
        }

    }

    
    const api = axios.create({
        baseURL: API_ROOT,
        responseType: 'json',
        headers: headers
    })
    
  
    api.interceptors.response.use(function (response) {
        return response
    }, function (error) {
        return Promise.reject(error)
    })

    return api
}




const requests = {
    get: (url, data, externalURL) =>     
        createApi(data ? data.authToken ? data.authToken : null : null)
            .get(`${externalURL === undefined ? `${API_ROOT}${url}` : externalURL}`, data)
            .then(handleResponse)
            .catch(handleErrors),
    post: (url, data, externalURL, media) =>      
        createApi(data ? data.authToken ? data.authToken : null : null)
            .post(`${externalURL === undefined ? `${API_ROOT}${url}` : externalURL}`, data, media ? { headers: { 'content-Type': 'multipart/form-data' } } : '')
            .then(handleResponse)
            .catch(handleErrors),
    patch: (url, data) =>
        createApi(data ? data.authToken ? data.authToken : null : null)
            .patch(`${API_ROOT}${url}`, data)
            .then(handleResponse)
            .catch(handleErrors),
    put: (url, data, media) =>
        createApi(data ? data.authToken ? data.authToken : null : null)
            .put(`${API_ROOT}${url}`, data, media ? { headers: { 'content-Type': 'multipart/form-data' } } : '')
            .then(handleResponse)
            .catch(handleErrors),
    delete: (url, data) =>
        createApi(data ? data.authToken ? data.authToken : null : null)
            .delete(`${API_ROOT}${url}`)
            .then(handleResponse)
            .catch(handleErrors)
}

const Client = {
    clientDetails: () => axios.get('https://geoip-db.com/json/')
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error
        })
}

const Account = {
    getDashboard: (data) => requests.post('/user/get_user_dashboard/',data),
    accounts: (data) => requests.get(`/account/accounts/${data.limit ? `?limit=${data.limit}${data.offset ? `&offset=${data.offset}`:''}`:''}${data.limit? '&':'?' }${data.filters ? data.filters:''}`, data),
    getUserAccounts: (data) => requests.get(`/account/get_user_accounts/`, data),    
    getUserAccountbyRecruiterUUID: (data) => requests.post('/account/get_root_account_by_uuid/', data),
    getUserAccountbyUUID: (data) => requests.post('/account/get_user_accounts_by_uuid/', data),
    activateAndCreateAccount: (data) => requests.post('/account/create_user_accounts/', data),
    getActivatedAccountsRange: (data) => requests.get(`/account/accounts/activated_date_range/${data.from ? '?from=' + data.from + '&to=' + data.to + `&limit=${data.limit}&offset=${data.offset}` : `?limit=${data.limit}&offset=${data.offset}`}${data.query ? '&query=' + data.query : ''}`),
    placeChildAccount: (data) => requests.post('/account/place_child_account/', data),
    


    getAccountDetails: (data) => requests.get(`/account/accounts/${data}/`),
    getAccountsFirst: () => requests.get('/account/accounts/first/'),
    getTotalIcredit: () => requests.get('/account/accounts/get_total_icredit/'),
    getNetworkTree: (data) => requests.post(`/account/get_account_tree/`,data),
    getAccountTree: (data) => requests.post('/account/get_account_tree/', data),
    changeEmail: (data) => requests.post('/account/change_email/', data),
    changePassword: (data) => requests.post('/account/change_password/', data),
    changeProfilePic: (data) => requests.put('/account/change_profile_pic/', data, true),
    checkReferralCode: (data) => requests.post('/account/check_referral_code/', data),
    confirmOTP: (data) => requests.post('/account/confirm_otp/', data),
    requestOTP: (data) => requests.post('/account/email_otp/', data),
    forgotPassword: (data) => requests.post('/account/forgot_password/', data),
    isAuthenticated: (data) => requests.post('/account/is_authenticated/', data),
    login: (data) => requests.post('/account/login/', data),
    logout: (data) => requests.post('/account/logout/', data),
    referralCode: (data) => requests.get('/account/referral_code/', data),
    register: (data) => requests.post('/account/register/', data),
    resetPassword: (data) => requests.post('/account/reset_password/', data),
    updateAddress: (data) => requests.put('/account/update_address/', data),
    updateBillingAddress: (data) => requests.put('/account/update_billing_address/', data),
    updateShippingAddress: (data) => requests.put('/account/update_shipping_address/', data),
    updateEncashmentInfo: (data) => requests.put('/account/update_encashment_info/', data),
    getSearch: (data) => requests.get(`/account/accounts/search_network_tree/?search_field=${data}`),
    monitoringDirect: (data) => requests.get(`/account/accounts/direct/${data && data.limit ? `?limit=${data.limit}` : ''}${data && data.offset ? `&offset=${data.offset}` : ''}`),
    monitoringRegistered: (data) => requests.get(`/account/accounts/registered/${data && data.limit ? `?limit=${data.limit}` : ''}${data && data.offset ? `&offset=${data.offset}` : ''}`),
    monitoringDrBonuses: (data) => requests.get(`/account/total_dr_bonus/${data && data.limit ? `?limit=${data.limit}` : ''}${data && data.offset ? `&offset=${data.offset}` : ''}`),
    monitoringSmBonuses: (data) => requests.get(`/account/total_sm_bonus/${data && data.limit ? `?limit=${data.limit}` : ''}${data && data.offset ? `&offset=${data.offset}` : ''}`)
}

const Accounting = {
    getSoaUser: (data) => requests.get(`/accounting/fetch_soa_username/?username=${data.username}`, data),
    getSoaDate: (data) => requests.get(`/accounting/fetch_soa_date_range/${data.from ? '?from=' + data.from + '&to=' + data.to : ''}`, data),
    getAccounts: (data) => requests.get('/accounting/', data),
    addAccount: (data) => requests.post('/accounting/', data),
    getAccountCat: (data) => requests.get('/accounting/category/', data),
    editAccount: (uuid, data) => requests.put(`/accounting/${uuid}/`, data),
    deleteAccount: (data) => requests.delete(`/accounting/${data.uuid}/`, data),
    getEntry: (data) => requests.get('/accounting/entry/', data),
    addEntry: (data) => requests.post('/accounting/entry/', data),
    deleteEntry: (data) => requests.delete(`/accounting/entry/${data.uuid}/`, data),
    editEntry: (uuid, data) => requests.put(`/accounting/entry/${uuid}/`, data),
    getAccountsCategory: (data) => requests.get(`/accounting/?category=${data.uuid}`, data)
}

const Advertisement = {
    getAdvertisementTypes: (data) => requests.get('/advertisement/ad_type/', data),
    getAdvertisement: (data) => requests.get(`/advertisement/fetch_ad/?uuid=${data.uuid}&ad_type=${data.ad_type}`),
    getFbShareAds: (data) => requests.get(`/advertisement/?uuid=${data.uuid}&ad_type=${data.ad_type}`),
    addToHistorySharing: (data) => requests.post(`/advertisement/${data.uuid}/other_ads/`, { account: data.account }),
    addWatchingToHistory: (data) => requests.post(`/advertisement/${data.videoUuid}/watch/${data.type !== undefined ? `?type=${data.type}` : ''}`, { account: data.account })
}

const Cart = {
    getItems: (data) => requests.get('/cart/cart_item/', data),
    addItem: (data) => requests.post('/cart/cart_item/', data),
    getUserItems: (data) => requests.get(`/cart/cart_item/?limit=${data.limit}&offset=${data.offset}`,data),
    getFeesBreakdown: (data) => requests.post('/cart/cart_item/get_fees_breakdown/', data),
    editItem: (query, data) => requests.put(`/cart/cart_item/${query}/`, data),
    updateItem: (query, data) => requests.patch(`/cart/cart_item/${query}/`, data),
    deleteItem: (query, data) => requests.delete(`/cart/cart_item/${query}/`,data)
}

const Dashboard = {
    getAnnouncements: (data) => requests.get('/announcement/')
}

const Encashment = {
    payoutTransactions: (data) => requests.get(`/encashment/?limit=${data.limit}&offset=${data.offset}`),
    getPayoutList: (data) => requests.get(`/encashment/?from=${data.from}&to=${data.to}`),
    getApprovedPayout: (data) => requests.get(`/encashment/?status=Approved&limit=${data.limit}&offset=${data.offset}`),
    payoutRequest: (data) => requests.post('/encashment/', data),
    allPayoutModes: (data) => requests.get('/encashment/mode/', data),
    getEncashmentCategories: () => requests.get('/encashment/category/'),
    payoutModes: (data) => requests.get(`/encashment/mode/?category=${data.category}`),
    userPayoutDetails: (data) => requests.get('/encashment/user_payout_details/', data),
    addUserPayoutDetails: (data) => requests.post('/encashment/user_payout_details/', data),
    editUserPayoutDetails: (uuid, data) => requests.put(`/encashment/user_payout_details/${uuid}/`, data),
    deleteUserPayoutDetails: (data) => requests.delete(`/encashment/user_payout_details/${data.uuid}/`),
    encashmentDetails: (data) => requests.get(`/encashment/${data.reference_number}/`),
    approvePayoutRequest: (data) => requests.post(`/encashment/${data.reference_number}/approve/`),
    declinePayoutRequest: (data) => requests.post(`/encashment/${data.reference_number}/decline/`)
}

const Order = {
    getAdminOrders: (data) => requests.get(`/order/?limit=${data.limit}&offset=${data.offset}${data.status
        ? `&status=${data.status}` : ''}${data.order_number ? `&order_number=${data.order_number}` : ''}${data.from ? `&from=${data.from}` : ''}${data.to ? `&to=${data.to}` : ''}`),
    createOrder: (data) => requests.post('/order/confirm/', data),
    confirmPayment: (data) => requests.post('/order/confirm_payment/', data),
    getUserOrders: (data) => requests.get(`/order/own/?limit=${data.limit}&offset=${data.offset}`),
    getPickupLocations: (data) => requests.get('/order/pickup_location/', data),
    getOrder: (query, data) => requests.get(`/order/${query}/`, data),
    sendReceipt: (data, formData) => requests.post(`/order/${data}/send_receipt/`, formData, undefined, true),
    cancelOrder: (query) => requests.post(`/order/${query}/cancel/`),
    approveReceipt: (data) => requests.post(`/order/${data.order_number}/approve_receipt/`),
    rejectOrder: (data) => requests.post(`/order/${data.order_number}/reject/`),
    reuploadReceipt: (data) => requests.post(`/order/${data.order_number}/reupload/`),
    getPaynamics: (query, data) => requests.get(`/order/${query}/get_paynamics_request/?client_ip=${data}/`),
    updatePaynamics: (query, data) => requests.put(`/order/${query.order_number}/update_status/${query.new_status}/`, data),
    payThroughWallet: (data) => requests.post(`/order/${data}/pay_through_wallet/`)

}

const Product = {
    getProducts: (data) => requests.get('/product/', data),
    addProduct: (data) => requests.post('/product/', data),
    getProductBySlug: (query, data) => requests.get(`/product/${query}/`, data),
    updateProductBySlug: (query, data) => requests.put(`/product/${query}/`, data),
    useMaintenanceCode: (data) => requests.post('/product/tickets/use_maintenance_code/', { ticket_code: data.code, account: data.account }),
    getProductByName: (query, data) => requests.patch(`/product/${query}/`, data),
    deleteProduct: (query, data) => requests.delete(`/product/${query}/`, data),
    deleteAProduct: (data) => requests.delete(`/product/${data.product_slug}/`, data),
    deleteProduct: (data) => requests.delete('/product/tickets/', data),
    getOwnedTickets: (data) => requests.get(`/product/tickets/own/?limit=${data.limit}&offset=${data.offset}`),
    getAllOwnedTickets: (data) => requests.get('/product/tickets/own/'),
    getAllPendingTickets: () => requests.get('/product/tickets/pending_placement/'),
    sendCodeToMember: (data) => requests.post('/product/tickets/send_ticket_from_admin/', data),
    forwardTicket: (data) => requests.post(`/product/tickets/${data.uuid}/forward/`, data),
    activateFirst: (uuid) => requests.post(`/product/tickets/${uuid}/first_activation/`),
    getValidActivation: () => requests.get('/product/tickets/valid_activation/'),
    setTicketPlacement: (data) => requests.post(`/product/tickets/${data.uuid}/placement/`, data),
    getTickets: (data) => requests.get(`/product/tickets/?limit=${data.limit}&offset=${data.offset}`, data),
    searchTickets: (data) => requests.get(`/product/tickets/?limit=${data.limit}&offset=${data.offset}&ticket_code=${data.ticketCode}`, data),
    changeOwner: (data) => requests.post(`/product/tickets/${data.uuid}/change_owner/`, data)
}

const User = {
    getUser: (data) => requests.get('/user/get_own_object/', data),
    getUsers: (data) => requests.get(`/user/users/?limit=${data.limit}&offset=${data.offset}${data.searchText ? `&search=${data.searchText}` : ''}${data.activatefilter=="TRUE" ? `&is_activated=true` : ''}${data.activatefilter=="FALSE" ? `&is_activated=false` : ''}`,data),
    getUserGroup: (data) => requests.get('/user/groups/', data),
    getAdminGroup: (data) => requests.get('/user/groups/', data),
    addUserToStockist: (data) => requests.post('/user/set_as_stockist/', data),
    allStockiests: (data) => requests.get(`/user/stockists/?limit=${data.limit}&offset=${data.offset}`, data),
    getRecruiteesbyUUID: (data) => requests.post('/user/get_recruitees_by_uuid/', data),
}

const Market = {
    getIGroups: (data) => requests.get(`/market/groups/?limit=${data.limit}&offset=${data.offset}`),
    getIGroupById: (data) => requests.get(`/market/groups/${data.id}`),
    getITools: (data) => requests.get(`/market/tools/?limit=${data.limit}&offset=${data.offset}`),
    getIToolsById: (data) => requests.get(`/market/tools/${data.id}`)
}

const Wallet = {
    getTotalBalance: (data) => requests.get('​/wallet​/total_balance​/', data),
    addWalletBalance: (data) => requests.post('/wallet/topup/confirm/', data),
    getWalletTransactions: (data) => requests.get(`/wallet/transaction/?limit=${data.limit}&offset=${data.offset}${data.type !== null ? `&type=${data.type}` : ''}${data.from !== null && data.to !== null ? `&from=${data.from}&to=${data.to}` : ''}`)

}

export default {
    Client,
    Account,
    Accounting,
    Advertisement,
    Cart,
    Dashboard,
    Order,
    Product,
    User,
    Encashment,
    Market,
    Wallet
}
